import * as Yup from 'yup';
import { PASSWORD_RULE } from 'constants/IncorporationConstants';
/**
 * 영어, 숫자
 * 영어, 숫자 포함되어 있으면 true
 * @returns {*}
 */

export function engNumChar(message) {
  return this.test('engNumSomeSpecialChar', function (value) {
    const { path, createError } = this;
    if (value === undefined || value === null) return true;
    const reg = /^[a-z|A-Z|0-9|\s]+$/g;
    if (!value.match(reg)) {
      return createError({
        path,
        message: message || 'MB_M_ENG_NAME_VALIDATION',
      });
    }
    return true;
  });
}

// 이름 - START
/**
 * 첫글자가 ^ \ ,문자가 포함되거나
 * 첫글자가 빈문자열이면 True
 * @returns {*}
 */
export function checkSpecialNm(message) {
  return this.test('checkSpecialNm', function (value) {
    const { path, createError } = this;
    if (value === undefined || value === null) return true;
    if (value.indexOf('^') > -1 || value.indexOf('\\') > -1 || value.indexOf(',') > -1 || value.indexOf('"') > -1) {
      return createError({ path, message: message || 'MB_M_NAME_SPECIAL_VALID' });
    }
    return true;
  });
}

export const DATE_FORMAT_REG = /^\d{4}-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01])$/;

export function dateFromat(message) {
  return this.test('dateFromat', function (value) {
    const { path, createError } = this;
    if (value === undefined || value === null) return true;
    const reg = DATE_FORMAT_REG;
    if (!value.match(reg)) {
      return createError({
        path,
        message: message || 'BTY_W_T_DATE_FORMAT_ERROR',
      });
    }
    return true;
  });
}

export const validDateFromat = param => {
  return Yup.string().required().dateFromat().isValidSync(param);
};

/**
 * 메일 주소가 유효한지 체크
 * 입력한 mail이 정상적인 메일 주소라면 true
 * @param message
 * @returns {*}
 */
export function mailFormat(message) {
  return this.test('mailFormat', function (value) {
    const { path, createError } = this;
    const reg = /^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z._-])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*\.[a-zA-Z]{2,3}$/g;
    if (!value) return true;
    if (value.match(reg)) {
      return true;
    }
    return createError({ path, message: message || 'MB_M_INVALID_EMAIL' });
  });
}

/**
 * 외부메일 등록 시, 등록하는 메일의 도메인이 brity 관련 도메인인지 아닌지 체크
 * 입력한 mail이 domainList에 포함되어 있지 않으면 true
 * @param domainList
 * @param message
 * @returns {*}
 */
export function notIncludeBrityDomain(domainList, message) {
  return this.test('notIncludeBrityDomain', function (value) {
    const { path, createError } = this;
    if (!value) return true;
    const _domain = value.substring(value.indexOf('@'), value.length);
    if (domainList?.some(email => email === _domain)) {
      return createError({ path, message: message || 'MB_M_EXCEPT_MYSINGLE_ADDR' });
    }
    return true;
  });
}

// 비밀번호 - START
/**
 * 연속적으로 3개 문자가 반복되는지 확인
 * 3개의 문자가 연속적으로 반복되지 않는다면 true
 * @param message
 * @param digit
 * @returns {*}
 */
export function noRepeat(message, digit = 3) {
  return this.test('noRepeat', function (value) {
    const { path, createError } = this;
    const reg = new RegExp(`(.)\\1{${digit - 1}}`);
    if (!value) return true;
    if (value.match(reg)) {
      return createError({ path, message: message || 'MB_T_PASSWORD_RULE3' });
    }
    return true;
  });
}
/**
 * 3개 숫자가 연속적인 증가되는 숫자인지 확인
 * 3개 숫자가 연속적인 증가되는 숫자가 아니면 true
 * @param message
 * @returns {*}
 */
export function noSeqNum(message) {
  return this.test('noSeqNum', function (value) {
    const { path, createError } = this;
    if (!value) return true;
    const numbers = '01234567890';
    const repeatLength = Number(PASSWORD_RULE.PASSWORD_NOSEQNUM);
    const loopCnt = value.length - repeatLength + 1;
    if (loopCnt > 0) {
      for (let i = 0; i < loopCnt; i++) {
        const parts = value.substr(i, repeatLength);
        if (!isNaN(parts)) {
          const str = parts.toString();
          if (numbers.indexOf(str) > -1) {
            return createError({ path, message: message || 'MB_T_PASSWORD_RULE4' });
          }
        }
      }
    }
    return true;
  });
}
/**
 * 영어, 숫자, 특수문자 일부(!@#$%^&*)
 * 영어, 숫자, 일부 특수문자가 포함되어 있으면 true
 * @param message
 * @returns {*}
 */
export function isMixedCharDigitSomeSpecialChar(message) {
  return this.test('isMixedCharDigitSomeSpecialChar', function (value) {
    const { path, createError } = this;
    if (!value) return false;
    const reg = /^(?=.*[a-zA-Z])(?=.*[!@#$%^&*])(?=.*[0-9]).{3,}$/g;
    if (value.match(reg)) {
      return true;
    }
    return createError({ path, message: message || 'MB_M_INCLUD_SPECIAL_CHAR' });
  });
}
/**
 * 특수문자( [!@#$%&*^] )를 사용했는지 여부 확인
 * 특수문자를 사용했다면 true
 * @param message
 * @returns {*}
 */
export function financialChar(message) {
  return this.test('financialChar', function (value) {
    const { path, createError } = this;
    const reg = /^[a-zA-Z0-9 !@#$%&*^]+$/g;
    if (!value) return true;
    if (value.match(reg)) {
      return true;
    }
    return createError({ path, message: message || 'MB_M_INCLUD_SPECIAL_CHAR' });
  });
}

// 비밀번호 - END
/**
 * 입력된 값이 true인지 체크
 * @param message
 * @returns {*}
 */

export function isAgreementTrue(message) {
  return this.test('isAgreementTrue', function (value) {
    const { path, createError } = this;
    if (!value) return false;
    if (value === 'true') {
      return true;
    }
    return createError({ path, message: message || 'MB820' });
  });
}

/**
 * 공백이 포함되어 있는지 확인
 * 공백이 포함되어 있지 않으면 true
 * @param message
 * @returns {*}
 */
export function noSpace(message) {
  return this.test('noSpace', function (value) {
    const { path, createError } = this;
    if (!value) return true;
    const reg = /\s/g;
    if (value.match(reg)) {
      return createError({ path, message: message || 'MB_M_ID_NOTUSEDCHARACTOR_SPACE' });
    }
    return true;
  });
}

/**
 * 시작 글자가 공백인지 확인
 * 시작 글자가 공백이 아니면 true
 * @param message
 * @returns {*}
 */
export function noSpaceInFront(message) {
  return this.test('noSpaceInFront', function (value) {
    const { path, createError } = this;
    if (!value) return true;
    if (value.trim() === '' || value.charAt(0) === ' ') {
      return createError({ path, message: message || 'MB_M_SPACE_IN_FRONT_NOT_ALLOWED' });
    }
    return true;
  });
}

/**
 * 비밀번호에 userId, empNo가 포함되어있는지 여부 확인
 * 비밀번호에 userId, empNo가 없으면 true
 * @param param
 * @param message
 * @returns {*}
 */
export function includeUserInfoForUserIdEmpNo(param, message) {
  return this.test('includeUserInfo', function (value, testContext) {
    const { path, createError } = this;
    let _param = !param ? testContext.options?.parent?.userId.replace(/[._-]/g, '') : param.replace(/[._-]/g, '');
    if (!value || !_param) return true;

    if (_param.indexOf('@') > -1) {
      _param = _param.split('@')[0];
    }

    if (value.indexOf(_param) !== -1) {
      return createError({ path, message: message || 'MB_T_PASSWORD_RULE5' });
    }
    return true;
  });
}

/**
 * 비밀번호에 전화번호의 끝자리 정보가 포함되어 있는지 없는지 확인
 * 비밀번호에 전화번호 끝자리 정보가 없으면 true
 * @param param
 * @param message
 * @returns {*}
 */
export function includeUserInfoForTelNo(param, message) {
  return this.test('includeUserInfoForTelNo', function (value, testContext) {
    const { path, createError } = this;
    let arrayParam = !param ? testContext.options?.parent?.mphonNo : param;
    if (!value || !arrayParam) return true;

    if (!Array.isArray(arrayParam)) {
      arrayParam = arrayParam.split(',');
    }
    for (let i = 0; i < arrayParam.length; i++) {
      const splitTelNo = arrayParam[i].split('-');
      const splitTelNoLangth = splitTelNo[splitTelNo.length - 1].length;
      const lastTelNo =
        splitTelNoLangth > 4
          ? splitTelNo[splitTelNo.length - 1].slice(splitTelNoLangth - 4, splitTelNoLangth)
          : splitTelNo[splitTelNo.length - 1];
      if (value.indexOf(lastTelNo) !== -1) {
        return createError({ path, message: message || 'MB_T_PASSWORD_RULE5' });
      }
    }
    return true;
  });
}
